import React from 'react'

const AccountIcon = (props: any) => (
  <svg viewBox="0 0 14 14" fill="#0F121F" {...props}>
    <path d="M7.00004 2.3335C7.61888 2.3335 8.21237 2.57933 8.64996 3.01691C9.08754 3.4545 9.33337 4.04799 9.33337 4.66683C9.33337 5.28567 9.08754 5.87916 8.64996 6.31674C8.21237 6.75433 7.61888 7.00016 7.00004 7.00016C6.3812 7.00016 5.78771 6.75433 5.35012 6.31674C4.91254 5.87916 4.66671 5.28567 4.66671 4.66683C4.66671 4.04799 4.91254 3.4545 5.35012 3.01691C5.78771 2.57933 6.3812 2.3335 7.00004 2.3335ZM7.00004 8.16683C9.57837 8.16683 11.6667 9.211 11.6667 10.5002V11.6668H2.33337V10.5002C2.33337 9.211 4.42171 8.16683 7.00004 8.16683Z" />
  </svg>
)

export default AccountIcon
